import { useEffect, useRef, useState } from "react";
import "./GalleryVerticalSlider.scss";
import { Swiper, SwiperSlide } from "swiper/react";

import { A11y, Navigation } from "swiper/modules";
import GallerySlideCard from "../GallerySlideCard/GallerySlideCard";
import { GalleryI, PhotoI } from "@/interfaces/galleries/Galleries";
import { BsGrid } from "react-icons/bs";

interface GalleryVerticalSliderI {
  photos: { [key: string]: PhotoI[] };
  year: number;
  index: number;
  gallery: GalleryI;
  iX: number;
  iY: number;
  changeIy: (iY: number) => void;
}

function GalleryVerticalSlider(props: GalleryVerticalSliderI) {
  const { photos, year, index, gallery, iX, changeIy } = props;
  const [activeSwiperSlide, setActiveSwiperSlide] = useState<number>(0);
  const swiperRef = useRef<any>(null);

  const navigationPrevRef = useRef<any>(null);
  const navigationNextRef = useRef<any>(null);

  const onSlideChange = () => {
    if (iX === index) {
      changeIy(swiperRef.current.activeIndex);
    }
    setActiveSwiperSlide(swiperRef.current.activeIndex);
  };

  const handleSwiper = (swiper: any) => {
    swiperRef.current = swiper;
  };

  useEffect(() => {
    if (
      swiperRef.current &&
      navigationPrevRef.current &&
      navigationNextRef.current
    ) {
      swiperRef.current.params.navigation.prevEl = navigationPrevRef.current;
      swiperRef.current.params.navigation.nextEl = navigationNextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, [swiperRef.current, navigationPrevRef.current, navigationNextRef.current]);

  useEffect(() => {
    if (swiperRef.current && iX === index) {
      changeIy(swiperRef.current.activeIndex);
    }
  }, [iX]);
  return (
    <div className="gallery-vertical-slider-main-container">
      <div ref={navigationPrevRef}></div>
      <div ref={navigationNextRef}></div>
      <Swiper
        className="mySwiper2 swiper-v gallery-vertical-slider"
        direction={"vertical"}
        modules={[Navigation, A11y]}
        spaceBetween={50}
        onSwiper={(swiper) => handleSwiper(swiper)}
        scrollbar={{ draggable: true }}
        onSlideChange={() => onSlideChange()}
      >
        {photos[year]
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
          .map((photo, j: number) => {
            return (
              <SwiperSlide key={"gallery-vertical-slide-" + j}>
                <GallerySlideCard
                  mosaicPhotos={photos[photo.year]}
                  photo={photo}
                  number={j + 1}
                  totalPhotos={photos[year].length}
                  prevButton={navigationPrevRef}
                  nextButton={navigationNextRef}
                  activeSwiperSlide={activeSwiperSlide}
                  gallery={gallery}
                />
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
}

export default GalleryVerticalSlider;
